import React, { forwardRef } from 'react';
import Type from 'prop-types';
import { Link } from 'react-router-dom';
import { parseUrl } from 'query-string';
import { useUrlFormatter } from 'hooks';

const LinkWithRetainedParams = forwardRef(({ to: toProp, children, ...other }, ref) => {
  // maintain existing query params and merges in new ones
  const urlFormatter = useUrlFormatter(({ queryParams, formatUrl }) => {
    // return a function that takes a path and maintains a subset of filter params
    // when changing to it
    return (to) => {
      // pull out the extra params
      const { url: path, query: extraParams } = parseUrl(to);

      return formatUrl({ ...queryParams, ...extraParams }, path);
    };
  });

  return (
    <Link to={urlFormatter(toProp)} {...other} ref={ref}>
      {children}
    </Link>
  );
});

LinkWithRetainedParams.propTypes = {
  to: Type.oneOfType([Type.string, Type.object, Type.func]).isRequired,
  children: Type.node,
};

LinkWithRetainedParams.defaultProps = {
  children: null,
};

export default LinkWithRetainedParams;
